(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amada-shape-icons"] && !Shopify.designMode) return;
  try {
    
  function amadaShapeStep(track) {
    const items = [...track.querySelectorAll('.amada-shape-icons__item')];
    if (items.length < 2) {
      return items[0]?.getBoundingClientRect().width || track.clientWidth * 0.3;
    }
    return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
  }

  function amadaShapeSync(root) {
    const track = root.querySelector('[data-shape-rail]');
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    const left = track.scrollLeft;
    root.querySelector('[data-shape-prev]')?.toggleAttribute('disabled', left <= 2);
    root.querySelector('[data-shape-next]')?.toggleAttribute('disabled', left >= max || max <= 0);
  }

  function amadaShapeSelect(root, tab) {
    const track = root.querySelector('[data-shape-rail]');
    const panelId = tab.getAttribute('aria-controls');
    root.querySelectorAll('[data-shape-tab]').forEach((item) => {
      const on = item === tab;
      item.setAttribute('aria-selected', on ? 'true' : 'false');
      item.tabIndex = on ? 0 : -1;
    });
    root.querySelectorAll('[data-shape-panel]').forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
    if (!track) return;
    const item = tab.closest('.amada-shape-icons__item');
    if (!item) return;
    const trackBox = track.getBoundingClientRect();
    const itemBox = item.getBoundingClientRect();
    if (itemBox.left < trackBox.left || itemBox.right > trackBox.right) {
      track.scrollBy({ left: itemBox.left - trackBox.left, behavior: 'smooth' });
    }
  }

  function amadaShapeBind(root) {
    if (root.dataset.amadaBound === '1') return;
    root.dataset.amadaBound = '1';
    const track = root.querySelector('[data-shape-rail]');
    if (!track) return;

    root.querySelector('[data-shape-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -amadaShapeStep(track), behavior: 'smooth' });
    });
    root.querySelector('[data-shape-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: amadaShapeStep(track), behavior: 'smooth' });
    });
    track.addEventListener('scroll', () => amadaShapeSync(root), { passive: true });
    root.querySelectorAll('[data-shape-tab]').forEach((tab) => {
      tab.addEventListener('click', () => amadaShapeSelect(root, tab));
    });
    amadaShapeSync(root);
  }

  document.querySelectorAll('amada-shape-rail').forEach(amadaShapeBind);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
